import { Building } from 'lucide-react';
import { getFormattedTeamTypeFromKey } from '../../../utils/miscFunctions';
import Avatar from '../../Avatar';
import SubscribedPlanIndication from '../../ui/SubscribedPlanIndication';
import { useSelector } from 'react-redux';
import { getCompanyOnboardingStatusFromState } from '../../../states/slices/globalSlice';
import useUserAccount from '../../../hooks/userAccountHook';

interface CompanyInfoProps {
  isSidebarExpanded: boolean;
}

export default function CompanyInfo({ isSidebarExpanded }: CompanyInfoProps) {
  const { user } = useUserAccount();
  const onboardingStatus = useSelector(getCompanyOnboardingStatusFromState);

  if (!isSidebarExpanded) return null;

  return (
    <div className="py-5 px-3">
      <div className="flex items-center space-x-2">
        <div className={`w-auto rounded-full flex items-center justify-center ${user?.company?.logo == null ? 'bg-gray-200 dark:bg-darkBg-border p-3' : ''}`}>
          {user?.company?.logo ? (
            <Avatar 
              className={user?.company?.name && user?.company?.name.length > 20 ? `h-12 w-20` : ''} 
              size="sm" 
              src={user?.company?.logo} 
              nameInitials={user?.company?.name} 
            />
          ) : (
            <Building className="h-6 w-6 text-gray-700 dark:text-darkBg-mainText" />
          )}
        </div>
        <div className="flex flex-col">
          <h1 className="text-lg font-bold text-gray-900 dark:text-darkBg-mainText tracking-tight">
            {user?.company?.name || '-'}
          </h1>
          <p className="text-xs text-gray-500 dark:text-darkBg-subText">
            {user.company?.type ? getFormattedTeamTypeFromKey(user.company?.type) : '-'} 
            {user.isBroker() ? ` [MID ${user?.company?.id}]` : ''}
          </p>
          {user?.isBroker() && onboardingStatus?.companyInfo?.subscriptionPlanId && <SubscribedPlanIndication />}
        </div>
      </div>
    </div>
  );
}
